import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TDWOperationType, TDWModuleType, TDWActionType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { IAdvancedPermissionManager, IAdvancedPermissionInjectable } from './interface';
import ArkLoader from '@src/js/common/ark-extensions';
import { ADV_PERMISSION_EXTENSION } from '@src/js/common/ark-extensions/dc-components/menu-adv-permission/config';

/**
 * 高级权限面板
 */
export default class AdvancePermissionManager implements IAdvancedPermissionManager {
    // 注入进来的异化处理类
    private injectable: IAdvancedPermissionInjectable;

    public constructor(injectable: IAdvancedPermissionInjectable) {
        this.injectable = injectable;
    }

    public showDialog() {
        tdw({
            opername: TDWOperationType.DOC_EDITOR_TOPBAR_PC,
            module: TDWModuleType.MORE_MENU,
            action: TDWActionType.PERMISSION,
        });
        const container = this.getDialogContainer();
        const isAlreadyProcessed = this.injectable.showAdvancedPermissionDialog(container);
        if (isAlreadyProcessed) {
            // 已在异化逻辑中处理过，直接返回
            return;
        }
        // 展示默认弹窗
        this.showDCDialog(container);
    }

    private getDialogContainer(): HTMLElement {
        const containerID = 'avd-container';
        let containerDom = document.getElementById(containerID);
        if (!containerDom) {
            containerDom = document.createElement('div');
            containerDom.id = containerID;
            document.body.appendChild(containerDom);
        }
        return containerDom;
    }

    private async showDCDialog(container: HTMLElement): Promise<void> {
        const advPermission = await ArkLoader.extensionService.getExtension(ADV_PERMISSION_EXTENSION.name);
        const { creatorDomain, domainId, padId, padType, userId } = window.clientVars;
        advPermission.show({
            container,
            domainId,
            padId,
            creatorDomain,
            padType,
            userId,
            invokeFrom: 'TitleBar',
        });
    }
}
